import { parseImageJSON as e } from "./parseImageJSON.es.js";
// lib/Image/lib/consume.ts
var t = async ({ input: e }) => {
	if (Array.isArray(e)) throw Error("Image plugin expected single input, not a list/array");
	if (typeof e.data == "string") return n(e);
	if (!(e.data instanceof File)) throw Error("Image plugin expected File or string for consumation");
	return r(e);
};
function n(t) {
	let n = e(t.data);
	if (!n) throw Error("Image plugin could not parse JSON data");
	return {
		...t,
		data: {
			id: crypto.randomUUID(),
			class: "block",
			type: "core/image",
			properties: {
				src: n.proxy || n.href,
				href: n.href,
				...n.rel && { rel: n.rel },
				...n.type && { type: n.type },
				...n.uri && { uri: n.uri },
				text: n.text || "",
				credit: n.byline || "",
				width: n.width,
				height: n.height
			},
			children: [
				{
					type: "core/image/image",
					class: "void",
					children: [{ text: "" }]
				},
				{
					type: "core/image/text",
					class: "text",
					children: [{ text: n.text || "" }]
				},
				{
					type: "core/image/byline",
					class: "text",
					children: [{ text: n.byline || "" }]
				}
			]
		}
	};
}
async function r(e) {
	let { name: t, type: n, size: r } = e.data;
	return new Promise((i, a) => {
		let o = new FileReader();
		o.addEventListener("load", () => {
			if (typeof o.result != "string") {
				a(/* @__PURE__ */ Error(`Error when image dropped, resulted in ${typeof o.result}`));
				return;
			}
			let s = new window.Image();
			s.src = o.result, s.onload = () => {
				window.setTimeout(() => {
					i({
						...e,
						data: {
							id: crypto.randomUUID(),
							class: "block",
							type: "core/image",
							properties: {
								type: n,
								src: s.src,
								title: t,
								size: r,
								width: s.width,
								height: s.height
							},
							children: [
								{
									type: "core/image/image",
									class: "void",
									children: [{ text: "" }]
								},
								{
									type: "core/image/text",
									class: "text",
									children: [{ text: "" }]
								},
								{
									type: "core/image/byline",
									class: "text",
									children: [{ text: "" }]
								}
							]
						}
					});
				}, 1e3);
			};
		}, !1), o.readAsDataURL(e.data);
	});
}
export { t as consume };
